// ActualizarAreascontrolcambiosPage.tsx
import { SaveAreascontrolcambios } from "../../components";
import {  useParams } from "react-router-dom";
// import { useFetchGetByIdAreascontrolcambios } from "@/shared/actions/auditoria/Areascontrolcambios.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdAreascontrolcambios } from "@/shared/actions";

export default function UpdateAreascontrolcambiosPage() {

  // useCheckPermissions(PermissionsEnum.api_change_areascontrolcambios);

  const { id: areaId } = useParams();

  const {data, isLoading, isRefetching} = useFetchGetByIdAreascontrolcambios(areaId!)


  if (
    isLoading ||
    isRefetching
  ) return <LoaderComponent />;

  // if (!data?.data) 
  //   return <Navigate to={'/'} />;

  return (
    <SaveAreascontrolcambios
      titulo="Actualizar Areas del control de cambios"
      data={data?.data}
    />
  );
}
